import { InputLabel } from '@material-ui/core';

const Version = () => <InputLabel>UI Version 3.2.1</InputLabel>;
export default Version;
